import filtersKeys from 'constants/filters';
import { FilterTypes } from 'constants/FilterTypes';
import modes from 'components/ui/buttonsGroup/modes';

export const quickFiltersConfig = [
  {
    filterId: filtersKeys.status,
    type: FilterTypes.buttonsList,
    mode: modes.single,
    view: 'separate',
    list: [
      { id: 'done', text: 'statuses.done' },
      { id: 'processing', text: 'statuses.processing' },
      { id: 'awaiting clarification', text: 'statuses.clarification' },
    ],
  },
  {
    filterId: filtersKeys.date,
    type: FilterTypes.dateButtons,
  },
];
